export default "__VITE_ASSET__6c161645__"